// Robust clipboard copy that works inside iframes/preview environments where
// the async Clipboard API may be blocked. Falls back to a hidden textarea +
// document.execCommand("copy") when needed.
export function fallbackCopy(value) {
  if (value == null) return false;
  const text = String(value);
  // Try the modern async API first when available
  if (typeof navigator !== "undefined" && navigator.clipboard && window.isSecureContext) {
    try {
      navigator.clipboard.writeText(text).catch(() => execCopy(text));
      return true;
    } catch {
      return execCopy(text);
    }
  }
  return execCopy(text);
}

function execCopy(text) {
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "0";
    ta.style.left = "0";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
